/**
 * BreakpointController - Reactive Controller für Breakpoint Detection
 * 
 * Verwendet Media Queries, um den aktuellen Breakpoint zu erkennen.
 * Ähnlich wie React Hooks - kapselt wiederverwendbare Logik.
 * 
 * @author jjarolim
 */

import type { ReactiveController, ReactiveControllerHost } from 'lit'
import { watchBreakpoint, getBreakpoint, type Breakpoint } from './breakpoint'

export class BreakpointController implements ReactiveController {
    private _host: ReactiveControllerHost
    private _breakpoint: Breakpoint | null = null
    private _cleanup?: () => void
    private _callback: ((breakpoint: Breakpoint | null) => void) | null = null

    constructor(
        host: ReactiveControllerHost,
        callback?: (breakpoint: Breakpoint | null) => void
    ) {
        this._host = host
        this._callback = callback ?? null
        this._breakpoint = getBreakpoint()
        host.addController(this)
    }

    get breakpoint(): Breakpoint | null {
        return this._breakpoint
    }

    hostConnected(): void {
        this._cleanup = watchBreakpoint((change) => {
            const newBreakpoint = change.to
            if (this._breakpoint?.name !== newBreakpoint?.name) {
                this._breakpoint = newBreakpoint
                if (this._callback) {
                    this._callback(newBreakpoint)
                }
                // Trigger update im Host
                this._host.requestUpdate()
            }
        })
    }

    hostDisconnected(): void {
        if (this._cleanup) {
            this._cleanup()
            this._cleanup = undefined
        }
    }

    hostUpdate(): void {
        // Wird vor jedem Update aufgerufen
    }

    hostUpdated(): void {
        // Wird nach jedem Update aufgerufen
    }
}
